module.exports = __webpack_public_path__ + "img/wine_default_primary_img.1c296701.png";